<template>
  <div>
    <SetupAnalyticContainer
      v-if="currentEvent.sponsors.length == 0"
      containerTitle="Sponsor Click Count"
      containerSubtitle="No. of people clicking on the sponsors section."
      bodyTitle="You have not set up sponsors for your event"
      description="Once it has been set up, the sponsor’s click count will appear here."
      btnText="Set up sponsors for your event"
      @click="currentEvent.currentTab = 1"
    />
    <v-card
      outlined
      v-else-if="currentEvent.sponsorsAnalytics.length == 0"
      max-height="500"
    >
      <v-card-title>Sponsor Click Count</v-card-title>
      <v-card-subtitle
        >No. of people clicking on the sponsors section.</v-card-subtitle
      >
      <v-divider></v-divider>
      <v-card-text
        class="pa-0 grey lighten-5 overflow-y-auto"
        style="max-height: 450px; height: 450px"
      >
        <v-row>
          <template v-for="(item, index) in currentEvent.sponsors">
            <v-col cols="6" :key="`sposnorName${index}`" class="pl-8">
              {{ item.name }}
            </v-col>
            <v-col cols="3" :key="`sposnorField2${item.uid}`">-</v-col>
            <v-col cols="3" :key="`sposnorField3${item.uid}`">-</v-col>
            <v-col
              cols="12"
              :key="`sposnorField4${item.uid}`"
              class="pt-0"
              v-if="index < currentEvent.sponsors.length - 1"
            >
              <v-divider></v-divider>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined v-else max-height="500">
      <v-card-title>Sponsor Click Count</v-card-title>
      <v-card-subtitle
        >No. of people clicking on the sponsors section.</v-card-subtitle
      >
      <v-divider></v-divider>
      <v-card-text
        class="pa-0 grey lighten-5 overflow-y-auto"
        style="max-height: 450px"
      >
        <v-tabs v-model="tab">
          <v-tab class="text-capitalize">No. of sponsors/partners</v-tab>
          <v-tab class="text-capitalize">Sponsor/Partner Clicks</v-tab>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card-subtitle>
                <div class="d-flex justify-start align-center">
                  <img
                    src="@/assets/total-sponsor-icon.svg"
                    height="15"
                    class="mr-1"
                    width="50"
                  />
                  <div>{{ totalSponsors }} sponsors/partners</div>
                </div>
              </v-card-subtitle>
              <v-divider />
              <v-row>
                <v-col class="pl-8">{{ currentEvent.name }}</v-col>
                <div class="d-flex justify-end mr-8">
                  <v-col class="pl-8">
                    {{ currentEvent.sponsors.length }}</v-col
                  >
                </div>
              </v-row>
              <template v-for="(item, index) in linkedSubEvents">
                <v-divider :key="`subEventDivider${index}`" />
                <v-row :key="`subEventRow${index}`">
                  <v-col cols="6" :key="`subEventName${index}`" class="pl-8">
                    {{ item.name }}
                  </v-col>
                  <v-col>
                    <div class="d-flex justify-end mr-8">
                      {{ item.sponsors.length }}
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-tab-item>
            <v-tab-item>
              <v-card-subtitle>
                <div class="d-flex justify-start align-center">
                  <img
                    src="@/assets/icons/subevent-icon.svg"
                    height="15"
                    class="mr-1"
                    width="50"
                  />
                  <div>{{ totalClicks }} clicks</div>
                </div>
              </v-card-subtitle>
              <v-row>
                <template v-for="(item, index) in sponsorAnalytics">
                  <v-col cols="6" :key="`sponsorName${index}`" class="pl-8">
                    {{ item.sponsorName }}
                  </v-col>
                  <v-col cols="3" :key="`sponsorClickCount${index}`">{{
                    getClickCount(item)
                  }}</v-col>
                  <v-col cols="3" :key="`viewBtn${index}`"
                    ><v-btn
                      text
                      small
                      color="primary"
                      @click="viewClickCount(item)"
                      >View</v-btn
                    ></v-col
                  >
                  <v-col
                    cols="12"
                    :key="item.uid"
                    class="pt-0"
                    v-if="index < sponsorAnalytics.length - 1"
                  >
                    <v-divider></v-divider>
                  </v-col>
                </template>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
    </v-card>

    <ViewClickDetailsDialog
      v-if="showClickDetailsDialog"
      :show="showClickDetailsDialog"
      dialogTitle="Sponsor Name click count"
      :totalClickOrShareCount="getClickCount(selectedSponsorAnalytic)"
      :analyticData="selectedSponsorAnalytic.clickData"
      @close="showClickDetailsDialog = false"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SetupAnalyticContainer from "./SetupAnalyticContainer";
import ViewClickDetailsDialog from "./ViewClickDetailsDialog";

export default {
  components: {
    SetupAnalyticContainer,
    ViewClickDetailsDialog,
  },
  computed: {
    ...mapGetters(["currentEvent", "linkedSubEvents"]),
    totalSponsors() {
      let currentEventSponsors = this.currentEvent.sponsors.length;
      let subEventSponsor = 0;
      this.linkedSubEvents.forEach((subEvent) => {
        subEventSponsor += subEvent.sponsors.length;
      });
      return subEventSponsor + currentEventSponsors;
    },
    totalClicks() {
      let totalClicks = 0;
      this.currentEvent.sponsorsAnalytics.forEach((sponsorAnalytic) => {
        totalClicks += this.getClickCount(sponsorAnalytic);
      });
      return totalClicks;
    },
    sponsorAnalytics() {
      let arr = [...this.currentEvent.sponsorsAnalytics];
      this.linkedSubEvents.forEach((subEvent) => {
        if (subEvent.sponsorsAnalytics.length > 0)
          arr.push(...subEvent.sponsorsAnalytics);
      });
      return arr;
    },
  },
  data() {
    return {
      showClickDetailsDialog: false,
      selectedSponsorAnalytic: null,
      tab: 0,
    };
  },
  methods: {
    getClickCount(sponsorAnalytic) {
      let count = 0;
      sponsorAnalytic.clickData.forEach((item) => {
        count += item.clickCount;
      });
      return count;
    },
    viewClickCount(sponsorAnalytic) {
      this.showClickDetailsDialog = true;
      this.selectedSponsorAnalytic = sponsorAnalytic;
    },
  },
};
</script>

<style>
</style>